module.exports = __webpack_public_path__ + "static/media/pointsGreen.04541cd1.svg";